module.exports = __webpack_public_path__ + "media/images/ic-search-55b8a6479ec0ceb1c4411d8f55ebb834.svg";